import { useState, useEffect } from 'react';
import styled from 'styled-components';

interface AddToHomeScreenInstance {
  show: (language?: string) => void;
  hide: () => void;
}

declare global {
  interface Window {
    AddToHomeScreenInstance: AddToHomeScreenInstance;
  }
}

const InstallCard = styled.div`
  background: linear-gradient(135deg, #0066CC 0%, #0052A3 100%);
  color: white;
  padding: 20px;
  border-radius: 16px;
  margin: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 4px 20px rgba(0, 102, 204, 0.2);
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 30px rgba(0, 102, 204, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    margin: 15px;
    padding: 16px;
  }
`;

const IconContainer = styled.div`
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  img {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  svg {
    width: 24px;
    height: 24px;
    fill: white;
  }
`;

const TextContainer = styled.div`
  flex: 1;
`;

const Title = styled.h3`
  margin: 0 0 4px 0;
  font-size: 18px;
  font-weight: 600;
`;

const Description = styled.p`
  margin: 0;
  font-size: 14px;
  opacity: 0.9;
`;

const ArrowIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
`;

export function InstallAppButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Only show button on mobile devices and when not already installed
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    // Check if running in standalone mode (already installed)
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches
      || ('standalone' in window.navigator && (window.navigator as { standalone?: boolean }).standalone === true);

    setIsVisible(isMobile && !isStandalone);
  }, []);

  if (!isVisible) {
    return null;
  }

  const handleInstallClick = () => {
    // Use the "calling UI later" approach from the documentation
    if (window.AddToHomeScreenInstance) {
      window.AddToHomeScreenInstance.show('it');
    } else {
      // Fallback to console message if library not loaded
      console.log('Add to homescreen library not available');
    }
  };

  return (
    <InstallCard onClick={handleInstallClick}>
      <IconContainer>
        <img src="/icons/Logo.svg" alt="CO2 App Icon" style={{width: '40px', height: '40px'}} />
      </IconContainer>
      <TextContainer>
        <Title>Installa l'app CO2</Title>
        <Description>Accesso rapido dalla tua schermata home</Description>
      </TextContainer>
      <ArrowIcon>
        <svg viewBox="0 0 24 24" fill="white">
          <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
        </svg>
      </ArrowIcon>
    </InstallCard>
  );
}